module.exports = __webpack_public_path__ + "img/1513842028.5ff6ba4c.jpg";